module.exports = "<p>\n  public-releases works!\n</p>\n"